const STORAGE_KEY = "table_rows_per_page";

export const readTableRows = (tableKey) => {
  try {
    const stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
    const val = parseInt(stored[tableKey], 10);
    return isNaN(val) ? null : val;
  } catch {
    return null;
  }
};

export const writeTableRows = (tableKey, value) => {
  try {
    const stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
    stored[tableKey] = value;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(stored));
  } catch {
    // ignore
  }
};
